import React from 'react';

function Brackets(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M8.79946 5.30809C8.5554 5.064 8.15967 5.06397 7.91558 5.30802L2.54891 10.6739L2.43362 10.8C1.81873 11.5367 1.85716 12.6336 2.54888 13.3253L7.91554 18.6919L8.0021 18.7643C8.24569 18.933 8.58247 18.9089 8.79943 18.6919C9.0435 18.4479 9.0435 18.0521 8.79943 17.8081L3.43276 12.4414L3.36039 12.3548C3.19152 12.1112 3.21564 11.7749 3.43276 11.5578L8.79939 6.19198L8.87172 6.10542C9.04048 5.86185 9.0164 5.52507 8.79946 5.30809ZM15.9978 5.23571C15.7542 5.06699 15.4174 5.09112 15.2005 5.30809C14.9564 5.55219 14.9565 5.94792 15.2006 6.19198L20.5672 11.5578L20.6396 11.6444C20.8084 11.888 20.7843 12.2243 20.5672 12.4414L15.2005 17.8081L15.1282 17.8946C14.9595 18.1382 14.9836 18.475 15.2005 18.6919C15.4446 18.936 15.8403 18.936 16.0844 18.6919L21.4511 13.3253L21.5664 13.1992C22.1812 12.4624 22.1428 11.3656 21.4511 10.6739L16.0844 5.30802L15.9978 5.23571Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Brackets;
